import React from 'react';
import styled from 'styled-components';

import { H1 } from 'partials/typography';
import Container from 'partials/Container';

export default props => {
    const { data, page } = props;

    const pageBackground = page && page.acf && page.acf.page_background ? page.acf.page_background : 'white';
    return (
        <Wrapper pageBackground={pageBackground} titlePlacement={data.title_placement}>
            <Container flex justify="flex-end">
                <H1>{data.custom_title || page.title.rendered}</H1>
            </Container>
        </Wrapper>
    );
}

const Wrapper = styled.div`
    padding-top: 120px;
    padding-bottom: 120px;
    @media(max-width: 767px) {
        padding-top: 20px;
        padding-bottom: 50px;
    }
    h1 {
        width:60%;
        padding-left:20px;
        ${props => props.pageBackground === 'main' ? `
            color: white;
        ` : ``}
        @media(max-width: 767px) {
            width: 100%;
            padding-left:0;
        }

        ${props => props.titlePlacement === 'left' ? `
            width:100%;
            padding-left:0;
            max-width: 960px;
            margin-left:auto;
            margin-right:auto;
        ` : ``}

        ${props => props.titlePlacement === 'center' ? `
            width:100%;
            padding-left:0;
            text-align:center;
        ` : ``}
    }
`


// WEBPACK FOOTER //
// ./src/partials/modules/PageTitle.js